var React = require('react');

function Warning (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8.75 11.75V10.25H7.25V11.75H8.75Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M8.75 8.75V4.25H7.25V8.75H8.75Z","fill":"currentColor","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM13.5 8C13.5 11.0376 11.0376 13.5 8 13.5C4.96243 13.5 2.5 11.0376 2.5 8C2.5 4.96243 4.96243 2.5 8 2.5C11.0376 2.5 13.5 4.96243 13.5 8Z","fill":"currentColor","key":2})]);
}

Warning.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Warning;

Warning.default = Warning;
